<template>
  <Block type="passportHeader" class="passport-header">
    <div class="login-account" :class="$platformClass" @click="copyUid">
      <img v-if="showIcon && showSwitchBtn" :src="showIcon.iconUrl" :alt="showIcon.iconAlt"
        :style="isFyym ? `width: 40px;` : ``" />
      <p class="display-name" :class="$platformClass">
        {{ displayName }}<br />(UID: {{ userId }})
      </p>
      <!-- <p
        class="user-id"
        style="display:none;"
      >(UID: {{ userId }})</p> -->
    </div>

    <!-- <Button type="swtichAccount" class="switch-btn" @click="logout"  v-show="showLogout&&showSwitchBtn"> -->

    <Button v-show="showLogout && showSwitchBtn && !isExeClient" type="swtichAccount"
      class="switch-btn j-switch-account-btn" :class="[extraClass, $platformClass]" @click="logout">
      <p class="switch-text" :class="$platformClass">
        {{ languages.switch.toUpperCase() }}
      </p>
      <Icon type="switch" class="switch-icon"></Icon>
      <Icon type="switchBtnLeft"></Icon>
      <Icon type="switchBtnRight"></Icon>
    </Button>
  </Block>
</template>

<script>
import bridge from '../../utiles/bridge'
import { LOGOUT } from '../../store/account'
import { getHrefParam } from '../../store/ultile'
import globalConfig from '../../utiles/globalConfig'
import { isIOS, isIpad } from '../../utiles/device'
import languageTool from '../../store/languages'
let gameId = getHrefParam('gameId')
let from = getHrefParam('from')
const mainHost = globalConfig.getMainHost()
const imageMainHost = globalConfig.getImageMainHost()
export default {
  props: ['showLogout', 'title'],
  data() {
    return {
      showSwitchBtn: gameId != 125,
      mainHostName: mainHost.replace('.com', ''),
      isExeClient: from == 'pnsClient' || from == 'exeClient',
      isFyym: +gameId === 280,
      fyymPlatformIcon: require("@assets/image/icons/user-icon-blue.png")
    }
  },
  mounted() { },
  computed: {
    extraClass() {
      let extraMap = {
        'zh-CN': 'CN',
        'ko-KR': 'KR',
        'zh-TW': 'CN',
        'th-TH': 'TH',
        'ja-JP': 'JP'
      }
      let lang = languageTool.getLanguage()
      return extraMap[lang] || false
    },
    platformIcon() {
      return this.$store.state.logoConfig.passportPlatformIcon
    },
    /**
     * 2024-04-08 改动登录方式图标，区分系统
     * IOS: 0-平台账号 1-facebook 2-google 3-game center 4-游客 5-推特 6-line 7-naver 8-Apple 9-vk 11-平台账号邮箱 12-平台账号手机
     * Android: 0-账号密码登录 1-fb登录 2-google登录 4-游客&引继码 5-推特 6-line 7-naver 9-华为 10-vk 11-email 12-phone
     * PC&微端：规则同Android
     */
    showIconMap() {
      return {
        'IOS': {
          0: {
            iconUrl: this.isFyym ? require("@assets/image/icons/user-icon-blue.png") : this.platformIcon,
            iconAlt: this.mainHostName
          },
          1: {
            iconUrl: require("@assets/image/passport/facebook.png"),
            iconAlt: 'facebook'
          },
          2: {
            iconUrl: require("@assets/image/passport/googlePlay.png"),
            iconAlt: 'googlePlay'
          },
          3: {
            iconUrl: require("@assets/image/passport/gameCenter.png"),
            iconAlt: 'gameCenter'
          },
          4: {
            iconUrl: this.isFyym ? require("@assets/image/icons/user-icon-blue.png") : this.platformIcon,
            iconAlt: this.mainHostName
          },
          5: {
            iconUrl: require("@assets/image/passport/twitter.png"),
            iconAlt: 'twitter'
          },
          6: {
            iconUrl: require("@assets/image/passport/line.png"),
            iconAlt: 'line'
          },
          7: {
            iconUrl: require("@assets/image/passport/naver.png"),
            iconAlt: 'naver'
          },
          8: {
            iconUrl: require("@assets/image/passport/apple.png"),
            iconAlt: 'apple'
          },
          9: {
            iconUrl: require("@assets/image/passport/vk.png"),
            iconAlt: 'vk'
          },
          11: {
            iconUrl: require("@assets/image/passport/email.png"),
            iconAlt: 'email'
          },
          12: {
            iconUrl: require("@assets/image/passport/phone.png"),
            iconAlt: 'phone'
          }
        },
        'Android': {
          0: {
            iconUrl: this.isFyym ? require("@assets/image/icons/user-icon-blue.png") : this.platformIcon,
            iconAlt: mainHost.replace('.com', '')
          },
          1: {
            iconUrl: require("@assets/image/passport/facebook.png"),
            iconAlt: 'facebook'
          },
          2: {
            iconUrl: require("@assets/image/passport/googlePlay.png"),
            iconAlt: 'googlePlay'
          },
          4: {
            iconUrl: this.isFyym ? require("@assets/image/icons/user-icon-blue.png") : this.platformIcon,
            iconAlt: mainHost.replace('.com', '')
          },
          5: {
            iconUrl: require("@assets/image/passport/twitter.png"),
            iconAlt: 'twitter'
          },
          6: {
            iconUrl: require("@assets/image/passport/line.png"),
            iconAlt: 'line'
          },
          7: {
            iconUrl: require("@assets/image/passport/naver.png"),
            iconAlt: 'naver'
          },
          9: {
            iconUrl: require("@assets/image/passport/hw.png"),
            iconAlt: 'hw'
          },
          10: {
            iconUrl: require("@assets/image/passport/vk.png"),
            iconAlt: 'vk'
          },
          11: {
            iconUrl: require("@assets/image/passport/email.png"),
            iconAlt: 'email'
          },
          12: {
            iconUrl: require("@assets/image/passport/phone.png"),
            iconAlt: 'phone'
          }
        }
      }
    },
    showIcon() {
      const type = parseInt(this.$store.state.accountSetting.originUserType, 10)
      return this.showIconMap[isIOS() || isIpad() ? 'IOS' : 'Android'][type] || null
    },
    userId() {
      let userIdCache = localStorage.getItem('userId')
      return (
        this.$store.state.account.userId ||
        userIdCache ||
        getHrefParam('userId')
      )
    },
    displayName() {
      let displayNameCache = localStorage.getItem('displayName')
      return this.$store.state.account.displayName || displayNameCache
    },
    languages() {
      return this.$store.state.passport.languages
    }
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT, {})
    },
    copyUid() {
      bridge.callSdkMethod('copyText', {
        content: this.userId + ''
      })
    }
  }
}
</script>